import * as React from 'react';
import { connect } from 'react-redux';
import { fetchUsuario, editUsuario, resetUsuario, fetchUsuarios, userTypeIds, updateListUsuarios } from '../../actions/usuariosActions';
import { fetchSeller } from '../../actions/sellersActions';
import { editUser, putActivarUsuario, putPausarUsuario, deshabilitarMfaUsuarioApi, obtenerTiposUsuarioApi, impersonateUserApi, postSearchTokenUsuario } from '../../api/axios';
import { toast } from '../../utilities/appToast';
import { isEmail } from '../../utilities/formatString';
import PasswordValidation from './PasswordValidation';
import GoBackArrow from '../General/GoBackArrow';
import BigSpinner from '../General/BigSpinner';
import Auth from '../../auth';
import '../General/AdminListCard.css';
import { encryptPassword } from '../../utilities/encryptPassword';
import { withNavigation } from '../General/withNavigation';
import PropTypes from 'prop-types';
import { isEmpty } from '../../utilities/isEmpty';
import { DropDownTipoUsuario, MfaState, UserActive, PermissionsColumn, Token, ConfirmModal, InputPassword, Input } from '../Usuarios';

class UserEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            usuarioError: false,
            password: "",
            confirmPassword: "",
            passValidation: false,
            hiddenItems: [],
            soloLectura: false,
            activo: true,
            showSpinner: false,
            localTipoUsuario: 0,
            localIdUsuario: 0,
            token: '',
            limiteCaracteresExcedido: false,
            tiposUsuario: [],
            showConfirmModal: false,
            showMfaConfirmModal: false,
            showImpersonationModal: false,
            impersonationLoading: false
        };
        this.emailUsuarioInputRef = React.createRef();
    };

    parseResetTokenResponse = (raw) => {
        let res = raw;
        if (typeof raw === "string") {
            try {
                res = JSON.parse(raw);
            } catch {
                res = {};
            }
        }
        const token =
            res?.token ||
            res?.Token ||
            res?.resetToken ||
            res?.ResetToken ||
            res?.tokenResetPassword ||
            "";
        return (token || "").trim();
    };

    getIdUsuarioForToken = () => {
        const usuario = this.props.usuario || {};
        return usuario?.idUsuario || usuario?.IdUsuario || this.state.localIdUsuario;
    };

    fetchTokenUsuario = async (showToastOnError = false) => {
        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;
        if (isResetMode) return "";
        if (!this.canAccessTokenSection()) return "";

        const idUsuario = this.getIdUsuarioForToken();
        if (!idUsuario || Number.isNaN(Number(idUsuario)) || Number(idUsuario) <= 0) return "";

        try {
            const res = await postSearchTokenUsuario({ idUsuario: Number(idUsuario) });
            const token = this.parseResetTokenResponse(res?.data);
            this.setState({ token: token || "" });
            return token || "";
        } catch (err) {
            const data = err?.response?.data;

            //If token doesn't exist yet, Core may respond 400. Do not treat as a UI error.
            if (showToastOnError) {
                if (Array.isArray(data?.errores)) {
                    data.errores.forEach(e => {
                        toast.error(e);
                    });
                } else {
                    toast.error("No se pudo consultar el token.");
                }
            }

            this.setState({ token: "" });
            return "";
        }
    };

    canAccessTokenSection = () => {
        const { currentUserType, idUsuario, userType } = this.props;
        const targetUserId = Number(this.state.localIdUsuario || this.props.usuario?.idUsuario || this.props.usuario?.IdUsuario || 0);
        const targetTipoUsuario = Number(this.state.localTipoUsuario || this.props.usuario?.tipoUsuario || this.props.usuario?.TipoUsuario || 0);
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;
        if (isResetMode) return false;

        return currentUserType == userTypeIds.isCategory ||
            currentUserType == userTypeIds.isAdminMod ||
            (currentUserType == userTypeIds.isSellerAdmin &&
                (Number(idUsuario) == targetUserId || targetTipoUsuario == userTypeIds.isSeller));
    };

    componentDidMount() {
        const { usuario, match } = this.props;
        const userIdFromUrl = match?.params?.id;
        const { isResetMode, username } = this.props.location?.state || {};

        if (Number(userIdFromUrl) > 0) {
            if (usuario?.idUsuario != userIdFromUrl || isEmpty(usuario)) {
                this.props.fetchUsuario({ idUsuario: userIdFromUrl });
            } else {
                this.initializeUser(usuario, true);
            }
        } else if (Number(userIdFromUrl) === 0) {
            // Si estamos en modo reset con un username disponible, buscar el usuario por nombre
            // (esto ocurre cuando Login no devuelve el userId correctamente y navega a /Editar/0)
            if (isResetMode && username) {
                this.props.fetchUsuario({ usuario: username });
            } else {
                this.props.resetUsuario();
                this.initializeUser({
                    idUsuario: 0,
                    identificadores: [],
                    soloLectura: false,
                    baja: false,
                    tipoUsuario: 0
                }, true);
            }
        } else if (isResetMode && username) {
            this.props.fetchUsuario({ usuario: username });
        } else if (isEmpty(usuario) && !isResetMode) {
            this.goBack();
        } else {
            this.initializeUser(usuario, true);
        }
        this.fetchTiposUsuario();
    }

    fetchTiposUsuario = () => {
        obtenerTiposUsuarioApi().then(res => {
            if (res.data && Array.isArray(res.data)) {
                this.setState({ tiposUsuario: res.data });
            } else if (Array.isArray(res)) {
                this.setState({ tiposUsuario: res });
            }
        }).catch(() => {

        });
    }

    componentDidUpdate(prevProps) {
        const userIdFromUrl = this.props.match?.params?.id;

        // If in Create Mode (ID 0), do not react to props.usuario updates to prevent stale data injection
        if (userIdFromUrl === "0") return;

        if (this.props.usuario && this.props.usuario !== prevProps.usuario && JSON.stringify(this.props.usuario) !== "{}" && JSON.stringify(this.props.usuario) !== "[]") {
            this.initializeUser(this.props.usuario);
        }
    }

    initializeUser = (usuario, focusEmail = false) => {
        const hiddenItems = Array.isArray(usuario?.perfil)
            ? usuario.perfil
            : (Array.isArray(usuario?.identificadores) ? usuario.identificadores : []);
        const hasActivoFlag = typeof usuario?.activo === "boolean";
        const activo = hasActivoFlag ? usuario.activo : !usuario?.baja;

        this.setState({
            hiddenItems,
            soloLectura: usuario.soloLectura,
            activo,
            localTipoUsuario: Number(usuario?.tipoUsuario ?? usuario?.TipoUsuario ?? 0),
            localIdUsuario: usuario.idUsuario || usuario.IdUsuario
        }, () => {
            // Consultar token solo para perfiles que pueden verlo.
            if (this.canAccessTokenSection()) {
                this.fetchTokenUsuario(false);
            }
            if (focusEmail && this.emailUsuarioInputRef.current) {
                this.emailUsuarioInputRef.current.focus();
            }
        });
    }

    changePassword = (e) => {
        const { value } = e.target;

        if (value.length > 12) {
            if (!this.state.limiteCaracteresExcedido) {
                toast.warn("Excede los 12 caracteres, verifique");
                this.setState({ limiteCaracteresExcedido: true });
            }
            return;
        }

        this.setState({
            password: value,
            limiteCaracteresExcedido: false
        });
    }

    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    confirmPassword = (e) => {
        const { value } = e.target;
        this.setState(prevState => ({
            usuarioError: value !== prevState.password,
            confirmPassword: value
        }));
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        const { name, value } = event.target;

        const cleanValue =
            name === "nombreUsuario" || name === "email"
                ? value.trimStart()
                : value;

        const usuarioActualizado = {
            ...this.props.usuario,
            [name]: cleanValue
        };
        this.props.editUsuario(usuarioActualizado);
    };


    updateHiddenItems = (hiddenItems) => {
        this.setState({ hiddenItems });
    };

    onSwitchStateChange = () => {
        this.setState({ showConfirmModal: true });
    };

    handleConfirmSwitch = () => {
        const { activo, localIdUsuario } = this.state;

        this.setState(prevState => ({
            showConfirmModal: false,
            activo: !prevState.activo,
            didEdit: true,
            showSpinner: true
        }));

        const requestPromise = activo ? putPausarUsuario(localIdUsuario) : putActivarUsuario(localIdUsuario);

        const usuarioActualizado = { ...this.props.usuario, baja: activo, activo: !activo };
        this.props.editUsuario(usuarioActualizado);

        requestPromise
            .then(() => {
                toast.success("Estado editado exitosamente");
            })
            .catch(err => {
                // Revertir estado en caso de error
                this.setState({ activo: activo });

                const usuarioRevertido = {
                    ...this.props.usuario,
                    baja: !activo,
                    activo: activo
                };
                this.props.editUsuario(usuarioRevertido);

                if (err.response?.data?.errores) {
                    err.response.data.errores.forEach(error => toast.error(error));
                } else {
                    toast.error("No pudo editarse");
                }
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleCloseModal = () => {
        this.setState({ showConfirmModal: false });
    };

    handleTipoUsuarioChange = (selectedOption) => {
        const nuevoTipo = selectedOption.value;
        this.setState({
            localTipoUsuario: nuevoTipo,
            didEdit: true
        });

        const usuario = {
            ...this.props.usuario,
            tipoUsuario: nuevoTipo
        };
        this.props.editUsuario(usuario);
    };

    onSubmit = async (event) => {
        event.preventDefault();

        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        // Use props usage but default to empty/0 if missing in Reset Mode
        const { email, nombreUsuario, idUsuario = (isResetMode ? 0 : undefined), idSeller, soloLectura } = this.props.usuario || {};
        const { localTipoUsuario } = this.state;

        if (!isResetMode && !isEmail(email)) {
            if (email === "") {
                toast.warn("Ingrese un e-mail de usuario");
                return;
            }
            toast.warn("Mail incorrecto");
            return;
        }

        if (!isResetMode && nombreUsuario === "") {
            toast.warn("Ingrese un nombre de usuario");
            return;
        }

        if (idUsuario === this.props.idUsuario && this.state.usuarioError) {
            toast.warn("Las contraseñas no coinciden");
            return;
        }

        const { password, hiddenItems } = this.state;

        // Determine effective ID and fallback values for Reset Mode
        let effectiveId = idUsuario;
        let effectiveEmail = email;
        let effectiveUsuario = nombreUsuario;

        if (isResetMode && (!effectiveId || effectiveId === 0)) {
            // Primera opción: ID en la URL (el más confiable — el Login navega a /Usuarios/Editar/${userId})
            const urlId = this.props.match?.params?.id;
            if (urlId && urlId !== "0" && !Number.isNaN(Number(urlId))) {
                effectiveId = Number(urlId);
            }
            // Segunda opción: ID de la sesión en Redux
            else if (this.props.idUsuario && this.props.idUsuario > 0) {
                effectiveId = this.props.idUsuario;
            }
            // Fallback a location state username si los datos del usuario no cargaron aún
            if (!effectiveEmail && this.props.location?.state?.username) {
                effectiveEmail = this.props.location.state.username;
            }
            if (!effectiveUsuario && this.props.location?.state?.username) {
                effectiveUsuario = this.props.location.state.username;
            }
        }

        // En modo reset, si no se cargó el tipo del usuario todavía (queda en 0),
        // usar el tipo de la sesión activa como fallback para no enviar idTipoUsuario: 0 al Core API.
        const effectiveTipoUsuario = (localTipoUsuario && localTipoUsuario > 0)
            ? localTipoUsuario
            : (this.props.currentUserType || 0);

        let userUpdated = {
            idUsuario: effectiveId,
            idSeller: idSeller,
            email: effectiveEmail,
            usuario: effectiveUsuario ? effectiveUsuario.trim() : undefined,
            soloLectura: soloLectura,
            identificadores: hiddenItems,
            tipoUsuario: effectiveTipoUsuario,
            baja: !this.state.activo,
            modulos: []
        };

        if (password && password.length > 0) {
            userUpdated.nuevoPassword = encryptPassword(password);

            if (isResetMode && this.props.location?.state?.resetToken) {
                userUpdated.passwordActual = encryptPassword(this.props.location.state.resetToken);
            } else if (this.props.userCredentials?.password) {
                userUpdated.passwordActual = this.props.userCredentials.password;
            } else {
                userUpdated.passwordActual = "";
            }
        } else {
            userUpdated.nuevoPassword = "";
        }

        // Only unset if we still don't have an ID (which shouldn't happen if session is active)
        if (isResetMode && (!effectiveId || effectiveId === 0)) {
            userUpdated.email = undefined;
            userUpdated.usuario = undefined;
        }

        this.setState({ showSpinner: true });

        try {
            await editUser(userUpdated);
            toast.success("Usuario editado exitosamente");

            if (Array.isArray(this.props?.usuarios)) {
                this.props.updateListUsuarios(this.props.usuarios, userUpdated);
            }

            this.props.userType.isResetPassword ? this.onLogout() : this.goBack();
        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo editarse");
            }
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    onLogout = () => {
        Auth.logout();
        this.props.navigate("/login");
    }

    goBack = () => {
        this.props.resetUsuario()
        window.history.go(-1);
    }

    handleDisableMfa = () => {
        this.setState({ showMfaConfirmModal: true });
    };

    handleCloseMfaModal = () => {
        this.setState({ showMfaConfirmModal: false });
    };

    executeDisableMfa = () => {
        const { usuario } = this.props;
        const request = {
            IdUsuario: usuario.idUsuario
        };

        this.setState({ showSpinner: true, showMfaConfirmModal: false });

        deshabilitarMfaUsuarioApi(request)
            .then(() => {
                toast.success("MFA deshabilitado correctamente");
                // Actualizar el estado del usuario para reflejar MFA deshabilitado
                const updatedUser = { ...usuario, mfaConfirmado: false };
                this.props.editUsuario(updatedUser);
            })
            .catch((error) => {
                console.error("Error executeDisableMfa:", error);
                const data = error?.response?.data;

                if (Array.isArray(data?.errores)) {
                    data.errores.forEach(e => {
                        const mensaje = e?.item2 || "Error desconocido";
                        toast.error(mensaje);
                    });
                } else {
                    toast.error("Error al deshabilitar MFA");
                }
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleOpenImpersonationModal = () => {
        if (!this.props.canImpersonate) {
            toast.error("No tenes permisos para impersonar usuarios.");
            return;
        }

        this.setState({ showImpersonationModal: true });
    };

    handleCloseImpersonationModal = () => {
        this.setState({ showImpersonationModal: false });
    };

    startImpersonation = () => {
        const { usuario, idUsuario, impersonation, canImpersonate } = this.props;

        if (impersonation?.isActive) {
            toast.warn("Finaliza la impersonacion actual antes de iniciar otra.");
            return;
        }

        if (!canImpersonate) {
            toast.error("No tenés permisos para impersonar usuarios.");
            return;
        }

        if (!usuario?.idUsuario || usuario.idUsuario == idUsuario) {
            toast.warn("Seleccioná otro usuario para impersonar.");
            return;
        }

        this.setState({ impersonationLoading: true });

        impersonateUserApi({ IdUsuario: usuario.idUsuario })
            .then((res) => {
                const redirectPath = res?.tipoUsuario === 8 ? "/Liquidaciones" : "/";

                Auth.startImpersonation({
                    idSeller: res.idSeller,
                    userName: res.nombre,
                    tipoUsuario: res.tipoUsuario,
                    userId: res.userId,
                    hiddenItemsIds: res.hiddenItemsIds,
                    codProv: res.codProv,
                    impersonation: res.impersonation,
                    canImpersonate: !!res.canImpersonate
                }, res.token);

                this.setState({ showImpersonationModal: false });
                toast.success(`Ahora estas viendo la plataforma como ${res.nombre}`);
                this.props.navigate(redirectPath);
            })
            .catch((error) => {
                const errores = error?.response?.data;

                if (Array.isArray(errores)) {
                    errores.forEach(err => toast.error(err));
                } else if (Array.isArray(errores?.errores)) {
                    errores.errores.forEach(err => toast.error(err));
                } else {
                    toast.error(errores?.mensaje || "No se pudo iniciar la impersonacion");
                }
            })
            .finally(() => {
                this.setState({ impersonationLoading: false });
            });
    };

    changeShowSpinner = (value) => {
        this.setState({ showSpinner: value });
    }

    setToken = (token) => {
        this.setState({ token });
    }

    render() {
        const { userType } = this.props;

        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        const isCreateMode = this.props.match?.params?.id == "0";

        let usuario = this.props.usuario;

        if (isEmpty(usuario) && (isResetMode || isCreateMode)) {
            usuario = {
                idUsuario: 0,
                email: isResetMode ? (this.props.location?.state?.username || "") : "",
                nombreUsuario: isResetMode ? (this.props.location?.state?.username || "") : "",
                soloLectura: false,
                baja: false,
                identificadores: [],
                tipoUsuario: 0
            };
        }

        if (!userType || isEmpty(usuario)) {
            return (
                <div className="container py-4">
                    <div className="card admin-grupo-busqueda-shell border-0 bg-white admin-form-loading d-flex align-items-center justify-content-center py-5">
                        <BigSpinner message="Cargando datos del usuario..." />
                    </div>
                </div>
            );
        }

        // Permitir permisos de edición solo para Administrador Total (AdminMod=2) o Seller Admin
        const canEditUserItems = userType.isAdminMod || userType.isSellerAdmin;
        const colSize = (userType.isAdminMod || userType.isSellerAdmin) &&
            canEditUserItems ? "col-12" : "col-12 col-sm-6";

        const isResetFlow = userType.isResetPassword || this.props.location?.state?.isResetMode;
        const canImpersonateTarget =
            !!this.props.canImpersonate &&
            !isResetFlow &&
            !isCreateMode &&
            !this.props.impersonation?.isActive &&
            !!usuario?.idUsuario &&
            this.props.idUsuario != usuario.idUsuario;

        return (
            <form autoComplete="off" onSubmit={this.onSubmit} className="form-horizontal form-material mb-0">
                <div className="container py-2">
                    <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                        {isResetFlow ? (
                            <div className="admin-grupo-busqueda-header text-center py-4">
                                <img
                                    src="/img/logo-marketplace-megatone.png"
                                    alt="MegaMarket"
                                    style={{ maxWidth: '200px', marginBottom: '12px' }}
                                />
                                <p className="small text-body-secondary mb-0">Definí tu nueva contraseña para continuar.</p>
                            </div>
                        ) : (
                            <div className="admin-grupo-busqueda-header">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                    <div className="d-flex flex-wrap align-items-center gap-2">
                                        <button
                                            onClick={() => {
                                                this.props.resetUsuario();
                                            }}
                                            style={{ border: "none", background: "none" }}
                                            type="button"
                                        >
                                            <GoBackArrow />
                                        </button>
                                        <div>
                                            <h4 className="mb-0 text-body fw-semibold">Editar usuario</h4>
                                            <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                                                Datos de cuenta, estado, MFA y permisos de acceso.
                                            </p>
                                        </div>
                                    </div>
                                    {canImpersonateTarget && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={this.handleOpenImpersonationModal}
                                        >
                                            <i className="fa fa-user-secret me-2" aria-hidden="true" />
                                            {"Impersonar usuario"}
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="card-body px-4 pb-4 pt-2">
                            <div className="row g-3">
                                <div className="col-12 col-sm-6">
                                    <div className="row g-3">

                                        {!(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                            <>
                                                <Input
                                                    styles={colSize}
                                                    inputId="emailUserEdit"
                                                    label="Email"
                                                    value={usuario.email}
                                                    onChange={this.myChangeHandler}
                                                    placeholder="usuario@dominio.com"
                                                    name="email"
                                                    ref={this.emailUsuarioInputRef}
                                                />
                                                <Input
                                                    styles={colSize}
                                                    inputId="nameUserEdit"
                                                    label="Nombre de usuario"
                                                    value={usuario.nombreUsuario}
                                                    onChange={this.myChangeHandler}
                                                    name="nombreUsuario"
                                                    maxLength="40"
                                                />
                                            </>
                                        )}
                                        {/* Mostrar contraseña solo si es CreateMode o si el usuario NO es Category ni AdminMod */}
                                        {(isCreateMode || (this.props.currentUserType != userTypeIds.isCategory && this.props.currentUserType != userTypeIds.isAdminMod)) && (
                                            <>
                                                <InputPassword
                                                    styles={colSize}
                                                    inputId="passwordUserEdit"
                                                    label={userType.isResetPassword ? "Nueva contraseña" : "Contraseña"}
                                                    value={this.state.password}
                                                    onChange={this.changePassword}
                                                    autoComplete="new-password"
                                                />
                                                <InputPassword
                                                    styles={colSize}
                                                    inputId="confirmPasswordUserEdit"
                                                    label={userType.isResetPassword ? "Confirmar nueva contraseña" : "Confirmar contraseña"}
                                                    value={this.state.confirmPassword}
                                                    onChange={this.confirmPassword}
                                                    autoComplete="new-password"
                                                />

                                                <div className="col-12 d-inline">
                                                    <p className="label-oscura" style={{ fontWeight: "600" }} htmlFor="passwordValidation">Requisitos de contraseña</p>
                                                    <PasswordValidation
                                                        password={this.state.password}
                                                        isValidPassword={this.handlePassValidation}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {/* Campo Token - solo visible para Category, AdminMod, SellerAdmin (con restricciones) */}
                                        {!(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                                        (this.props.currentUserType == userTypeIds.isCategory ||
                                        this.props.currentUserType == userTypeIds.isAdminMod ||
                                        (this.props.currentUserType == userTypeIds.isSellerAdmin &&
                                                    (this.props.idUsuario == this.state.localIdUsuario || this.state.localTipoUsuario == userTypeIds.isSeller))) && (
                                            <Token
                                                colSize={colSize}
                                                token={this.state?.token}
                                                usuario={usuario}
                                                generateResetPasswordToken={this.generateResetPasswordToken}
                                                copyResetTokenToClipboard={this.copyResetTokenToClipboard}
                                                showSpinner={this.state?.showSpinner}
                                                isResetMode={userType?.isResetPassword || this.props.location?.state?.isResetMode}
                                                changeShowSpinner={this.changeShowSpinner}
                                                setToken={this.setToken}
                                                fetchTokenUsuario={this.fetchTokenUsuario}
                                                parseResetTokenResponse={this.parseResetTokenResponse}
                                            />
                                        )}
                                        <div className="col-12">
                                            <hr className="my-3 opacity-25" />
                                        </div>
                                        {/* Dropdown Tipo de Usuario - Para Admin y Seller Admin */}
                                        {(this.props.currentUserType == userTypeIds.isAdminMod || this.props.currentUserType == userTypeIds.isSellerAdmin) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                            <DropDownTipoUsuario userTypeIds={userTypeIds} localTipoUsuario={this.state?.localTipoUsuario} tiposUsuario={this.state?.tiposUsuario} currentUserType={this.props.currentUserType} handleTipoUsuarioChange={this.handleTipoUsuarioChange} />
                                        )}
                                        {(this.props.currentUserType == userTypeIds.isCategory || this.props.currentUserType == userTypeIds.isAdminMod) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                                            <UserActive onSwitchStateChange={this.onSwitchStateChange} activo={this.state?.activo} />
                                        }
                                        {/* Estado MFA y Botón Deshabilitar */}
                                        {(this.props.currentUserType == userTypeIds.isCategory || this.props.currentUserType == userTypeIds.isAdminMod || userType.isSellerAdmin) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                            <MfaState usuario={usuario} handleDisableMfa={this.handleDisableMfa} showSpinner={this.state?.showSpinner} />
                                        )}
                                    </div>
                                </div>
                                {/* Columna de Permisos */}
                                {canEditUserItems && !(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                                    !((this.props.currentUserType === userTypeIds.isSellerAdmin) && (this.props.idUsuario == usuario.idUsuario)) &&
                                    <PermissionsColumn localTipoUsuario={this.state.localTipoUsuario} hiddenItems={this.state.hiddenItems} updateHiddenItems={this.updateHiddenItems} />
                                }
                            </div>
                        </div>

                        <div className="card-footer bg-transparent border-top px-4 py-3 text-end">
                            {!(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light me-2"
                                    onClick={this.goBack}
                                >
                                    Cancelar
                                </button>
                            }
                            <button
                                type="submit"
                                className="btn btn-sm background-rojo-megatone px-4"
                                disabled={this.state.showSpinner}
                            >
                                {this.state.showSpinner && <output className="spinner-border spinner-border-sm me-2" aria-hidden="true" />}
                                Guardar cambios
                            </button>
                        </div>
                    </div>
                </div>

                <ConfirmModal show={this.state.showConfirmModal} onHide={this.handleCloseModal} title={this.state.activo ? "Desactivar Usuario" : "Activar Usuario"} variantConfirm={this.state.activo ? "danger" : "success"} handleCancel={this.handleCloseModal} handleConfirm={this.handleConfirmSwitch}>
                    ¿Estás seguro de que deseas {this.state.activo ? "desactivar" : "activar"} este usuario?
                </ConfirmModal>

                <ConfirmModal show={this.state.showImpersonationModal} onHide={this.handleCloseImpersonationModal} title="Impersonar usuario" handleCancel={this.handleCloseImpersonationModal} disabledCancel={this.state.impersonationLoading} handleConfirm={this.startImpersonation} textConfirm={this.state.impersonationLoading ? "Ingresando..." : "Confirmar impersonacion"} disabledConfirm={this.state.impersonationLoading}>
                    Vas a ingresar como <strong>{usuario?.nombreUsuario || usuario?.email || "este usuario"}</strong> y vas a heredar su vista, permisos, <code>idUsuario</code>, <code>codProv</code> e <code>idSeller</code>.
                    <br />
                    <br />
                    Tu sesion actual quedara guardada temporalmente para que puedas volver desde el menu superior.
                </ConfirmModal>

                <ConfirmModal show={this.state.showMfaConfirmModal} onHide={this.handleCloseMfaModal} title="Deshabilitar MFA" handleCancel={this.handleCloseMfaModal} handleConfirm={this.executeDisableMfa}>
                    ¿Estás seguro de que deseas deshabilitar la autenticación de dos factores para este usuario?
                </ConfirmModal>
            </form >
        );
    }
}
UserEdit.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.shape({
            isResetMode: PropTypes.bool,
            username: PropTypes.string,
            resetToken: PropTypes.string,
        }),
    }),
    navigate: PropTypes.func,
    // Redux props
    usuario: PropTypes.oneOfType([PropTypes.shape({
        idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nombreUsuario: PropTypes.string,
        email: PropTypes.string,
        mfaConfirmado: PropTypes.bool,
    }), PropTypes.array]),
    userType: PropTypes.shape({
        isResetPassword: PropTypes.bool,
        isAdminMod: PropTypes.bool,
        isSellerAdmin: PropTypes.bool
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
    idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currentUserType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userCredentials: PropTypes.shape({
        password: PropTypes.string,
    }),
    canImpersonate: PropTypes.bool,
    impersonation: PropTypes.shape({
        isActive: PropTypes.bool,
    }),
    usuarios: PropTypes.array,
    // Actions props
    fetchUsuario: PropTypes.func,
    resetUsuario: PropTypes.func,
    editUsuario: PropTypes.func,
    updateListUsuarios: PropTypes.func,
}

const mapStateToProps = state => ({
    usuario: state.usuarios.usuario,
    usuarios: state.usuarios.usuarios,
    userType: state.general.userType,
    idUsuario: state.general.userId,
    currentUserType: state.general.tipoUsuario,
    userCredentials: state.general.userCredentials,
    impersonation: state.general.impersonation,
    canImpersonate: state.general.canImpersonate
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuario, editUsuario, resetUsuario, fetchUsuarios, fetchSeller, updateListUsuarios
})(UserEdit));
